export default "__VITE_ASSET__C7xiRu95__"